import React, { useEffect, useState } from "react";
import "./NewPortfolio.css";
import AOS from "aos";
import "aos/dist/aos.css";
import myreeldrem from '../Images/myreeldrem.png'
import bnbyond from "../Images/bnbyond.png"
import dripnbodied from '../Images/dripnbodied.png'
import HeaderPort from "./HeaderPort";
import HomePort from "./HomePort";
import SkillsPort from "./SkillsPort";
import ProjectPort from "./ProjectPort";
import ContactMe from "./ContactMe";
import FooterPort from "./FooterPort";
import AboutMe from "./AboutMe";
import movemuse from "../Images/movemuse.png";
const NewPortfolio = () => {
  const [hide, setHide] = useState(true);

  useEffect(() => {
    AOS.init();
    const handleWidth = () => {
      if (window.innerWidth < 786) {
        setHide(false);
      } else {
        setHide(true);
      }

      console.log("here is the hide : ", hide);
    };
    window.addEventListener("resize", handleWidth);

    return () => {
      window.removeEventListener("resize", handleWidth);
    };
  }, [hide, setHide]);
  const dataProject = [

    {
      Image: movemuse,
      title: "MoveMuse",
      paragrapgh:
        "  This website allows users to create upcoming dance events, view past events, and leave reviews on festivals. Users can also submit blogs to the admin, either to request new events or to provide feedback. To explore more details, click the link below",
      Link: "Visit Website",
      hreflink: "https://move-muse12.netlify.app/",
    },
   
    {
      Image: myreeldrem,
      title: "MYReelDrem",
      paragrapgh:
        "  THis website Allow users to buy movies packages to see more details click on below link ",
      Link: "Visit Website",
      hreflink: "https://www.myreeldream.ai/",
    },
   
    {
      Image: dripnbodied,
      title: "DripNBodied",
      paragrapgh:
        " This webiste is for Ddriped N Bodied And Massage to see more details click on below link  ",
      Link: "Visit Website",
      hreflink: "https://dripnbodied.com/",
    },
    {
    Image: bnbyond,
    title: "BnByond",
    paragrapgh:
      "This Website is for hotel to book romes and halls and many others services see more details click on below link   ",
    Link: "Visit Website",
    hreflink:
      "https://bnbyond.com/",
  },
  ];

  const skillsData = [
    { id: 3, name: "HTML", level: "Advance" },
    { id: 4, name: "CSS", level: "Advance" },
    { id: 1, name: "JavaScript", level: "Advance" },
    { id: 2, name: "React", level: "Advance" },
    { id: 11, name: "ReduxToolKit", level: "Advance" },
    { id: 5, name: "Next Js", level: "Advance" },
    { id: 8, name: "Bootstrap", level: "Advance" },
    { id: 9, name: "Tailwind Css", level: "Advance" },
    { id: 6, name: "MaterialUI", level: "Advance" },
    { id: 7, name: "GitHub", level: "Advance" },
    { id: 8, name: "Node js", level: "Advance" },
    { id: 9, name: "MongoDB ", level: "Advance" },
    { id: 10, name: "Express js ", level: "Advance" },
    { id: 11, name: "Git ", level: "Advance" },
  ];
  const [show, setShow] = useState(true);
  return (
    <div>
      <div className="container-fluid  mainDropFilter  " >
        <HeaderPort hide={hide} setHide={setHide} />
        <HomePort show={show} setShow={setShow} />
        <SkillsPort skillsData={skillsData} />
        <ProjectPort dataProject={dataProject} />
        <AboutMe />
        <ContactMe />
        <FooterPort />
      </div>
    </div>
  );
};

export default NewPortfolio;
